import './controllers/wos';

import initFontAwesome from 'utils/font_awesome_init';
initFontAwesome();

import reporter from 'utils/reporter';
reporter.init();
